var _excluded = ["className", "indent", "label", "option", "selectable", "updateOption"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import Input from "../Input/Input";
import ListGroupItem from "../List/ListGroupItem";

function updateSelection(selected, children) {
  return children === null || children === void 0 ? void 0 : children.map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      selected: selected,
      children: updateSelection(selected, option.children)
    });
  });
}

var count = 0;

var getID = function getID() {
  return "tree-item-".concat(count++);
};

function TreeItem(_ref) {
  var _option$children;

  var className = _ref.className,
      _ref$indent = _ref.indent,
      indent = _ref$indent === void 0 ? 0 : _ref$indent,
      label = _ref.label,
      option = _ref.option,
      _ref$selectable = _ref.selectable,
      selectable = _ref$selectable === void 0 ? false : _ref$selectable,
      updateOption = _ref.updateOption,
      props = _objectWithoutProperties(_ref, _excluded);

  var selectAllRef = useRef(null);

  var _useState = useState(getID()),
      _useState2 = _slicedToArray(_useState, 1),
      checkboxId = _useState2[0];

  var showExpand = option.children && ((_option$children = option.children) === null || _option$children === void 0 ? void 0 : _option$children.length) > 0;
  useEffect(function () {
    if (selectAllRef && selectAllRef.current && option.children) {
      var _option$children2, _option$children3;

      var allSelected = (_option$children2 = option.children) === null || _option$children2 === void 0 ? void 0 : _option$children2.every(function (child) {
        return child.selected;
      });
      var noneSelected = (_option$children3 = option.children) === null || _option$children3 === void 0 ? void 0 : _option$children3.every(function (child) {
        return child.selected === false;
      }); // @ts-ignore

      selectAllRef.current.indeterminate = !allSelected && !noneSelected;
    }
  }, [option]);
  return /*#__PURE__*/React.createElement(ListGroupItem, _extends({
    className: classnames('list-group-item', 'pl-2', 'text-truncate', className),
    style: {
      display: 'grid',
      gridTemplateColumns: showExpand ? "".concat(indent * 1.5, "rem ").concat(selectable ? '2rem' : '', " 2rem 1fr") : "".concat(indent * 1.5 + 2, "rem ").concat(selectable ? '2rem' : '', " 1fr"),
      alignItems: 'center'
    }
  }, props), /*#__PURE__*/React.createElement("div", null), showExpand ? /*#__PURE__*/React.createElement(Button, {
    color: "link",
    className: "rg-treeitem-expand py-0 px-0",
    onClick: function onClick() {
      return updateOption(option, {
        expanded: !option.expanded
      });
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "angle-down",
    rotate: option.expanded ? 180 : undefined,
    size: "lg"
  })) : null, selectable && /*#__PURE__*/React.createElement(Input, {
    checked: option.selected,
    className: classnames('rg-treeitem-checkbox', 'position-relative'),
    id: checkboxId,
    innerRef: selectAllRef,
    onChange: function onChange(e) {
      var newSelection = e.target.checked;
      var children = updateSelection(newSelection, option.children);
      updateOption(option, {
        children: children,
        selected: newSelection
      });
    },
    type: "checkbox",
    "data-testid": "tree-item-checkbox-input"
  }), /*#__PURE__*/React.createElement("div", {
    className: "js-tree-item-label w-100"
  }, label(option.item, option)));
}

TreeItem.displayName = "TreeItem";
export default TreeItem;